// export function generatePagesBar (count, current) {
//     try {
//       let blank = [1, "...", current - 1, current, current + 1, "...", count];
//       blank = blank.filter(
//         (button) =>
//           (typeof button === "number" && count >= button && button > 0) ||
//           button === "..."
//       );

//       const result = [];
//       for (let num = 0; num < blank.length; num++) {
//         const button = blank[num];
//         if (
//           typeof button !== "number" &&
//           result.length > 0 &&
//           num + 1 < blank.length - 1
//         ) {
//           result.push(button);
//           continue;
//         }
//         if (!result.includes(button) || button === "...") {
//           result.push(button);
//         }
//       }

//       if (result.length > 2 && result[2] === result[0] + 1) {
//         result.splice(1, 1);
//       }

//       if (typeof result[result.length - 1] === "string") {
//         result.pop();
//       } else if (result.length > 3 && result[result.length - 3] === result[result.length - 1] - 1) {
//         result.splice(-2, 1);
//       }

//       return result;
//     } catch (error) {
//       return [];
//     }
// }

export function generatePagesBar(count, current) {
    try {
        // Если всего 1 страница или меньше
        if (count <= 1) {
            return count === 1 ? [1] : [];
        }

        // Если страниц мало (до 7), показываем все
        if (count <= 7) {
            return Array.from({ length: count }, (_, i) => i + 1);
        }

        let pages = new Set();

        // Всегда добавляем первую и последнюю страницу
        pages.add(1);
        pages.add(count);

        // Добавляем текущую страницу и соседние
        pages.add(current);
        if (current > 1) pages.add(current - 1);
        if (current < count) pages.add(current + 1);

        // Добавляем страницы вокруг текущей для контекста
        if (current > 2) pages.add(current - 2);
        if (current < count - 1) pages.add(current + 2);

        // Преобразуем в массив и сортируем
        let result = Array.from(pages).sort((a, b) => a - b);

        // Добавляем многоточия где нужно
        let finalResult = [];
        for (let i = 0; i < result.length; i++) {
            finalResult.push(result[i]);
            
            // Добавляем многоточие если разрыв между страницами больше 1
            if (i < result.length - 1 && result[i + 1] - result[i] > 1) {
                finalResult.push("...");
            }
        }

        return finalResult;
    } catch (error) {
        console.error("Error in generatePagesBar:", error);
        return [];
    }
}